import { FarmsContainer } from '@/features/farms/FarmsContainer'

export function Farms() {
  return <FarmsContainer />
}
